/**
 * ForderungsmanagerPage — Route-Einstieg für den Forderungsmanager
 *
 * Standardmäßig zeigt /forderungen jetzt die native Seite (ForderungenSeite,
 * Firmen-Tabs + KPIs + Filter + Falltabelle + Detail mit Ein-/Ausgang) statt
 * nur den Drawer zu öffnen.
 *
 * Rückwärtskompatibel: ein Deep-Link mit ?akte_id öffnet weiterhin den
 * bestehenden ForderungsmanagerDrawer für genau diese Akte.
 */

import { useEffect } from 'react';
import { useApp } from '@/contexts/AppContext';
import ForderungenSeite from '@/components/forderungsmanager/ForderungenSeite';

export default function ForderungsmanagerPage() {
  const { openForderungsmanager } = useApp();

  useEffect(() => {
    // Wouter v3 useLocation() returns pathname only — use window.location.search for query params.
    const akteId = new URLSearchParams(window.location.search).get('akte_id') ?? undefined;
    // Nur bei Deep-Link auf eine konkrete Akte den Drawer öffnen.
    if (akteId) openForderungsmanager(akteId);
  }, [openForderungsmanager]);

  return <ForderungenSeite />;
}
